import { type IAdvertise } from '../../../store/slices/advertisesSlice'

export const reduceAdvertise = (entry: Record<any, any>, isMy: IAdvertise) => {
    const reduceAdvertise = {
        id: entry.id,
        attributes: {
            ...entry,
            User: {
                data: {
                    id: isMy?.attributes?.User?.data?.id ?? entry?.User?.id,
                    attributes: {}
                }
            },
            Unit: {
                data: {
                    id: isMy?.attributes?.Unit?.data?.id ?? entry?.Unit?.id,
                    attributes: {}
                }
            }

        }
    }
    return reduceAdvertise
}
